import React from "react";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import InvestmentItemAvatar from "../../../components/mui/material/InvestmentItemAvatar";
import GoalAvatar from "../../../components/mui/material/GoalAvatar";
import BrokerAvatar from "../../../components/mui/material/BrokerAvatar";
import NumericFormat from "../../../components/react-number-format/NumericFormat";
import { eventTypeIds } from "../../../constants";
var tKey = "wrappers.NotificationToastsDecorator.impl.OperationRelatedNotificationToast";
function OperationRelatedNotificationToast(props) {
  var notificationId = props.notificationId,
    eventTypeId = props.eventTypeId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  var operationId = notification.event.objects[0].objectId;
  var operation = useSelector(function (state) {
    return state.entities.operations.byId[operationId];
  });
  var headerKey;
  var bodyKey;
  if (eventTypeId === eventTypeIds.BUY_PENDING) {
    headerKey = "".concat(tKey, ".header_buyPending");
    bodyKey = "".concat(tKey, ".header_buyPending");
  } else if (eventTypeId === eventTypeIds.SELL_PENDING) {
    headerKey = "".concat(tKey, ".header_sellPending");
    bodyKey = "".concat(tKey, ".body_sellPending");
  } else if (eventTypeId === eventTypeIds.BUY_SUBMITTED) {
    headerKey = "".concat(tKey, ".header_buySubmitted");
    bodyKey = "".concat(tKey, ".body_buySubmitted");
  } else if (eventTypeId === eventTypeIds.SELL_SUBMITTED) {
    headerKey = "".concat(tKey, ".header_sellSubmitted");
    bodyKey = "".concat(tKey, ".body_sellSubmitted");
  } else if (eventTypeId === eventTypeIds.BUY_COMMITTED) {
    headerKey = "".concat(tKey, ".header_buyCommitted");
    bodyKey = "".concat(tKey, ".body_buyCommitted");
  } else if (eventTypeId === eventTypeIds.SELL_COMMITTED) {
    headerKey = "".concat(tKey, ".header_sellCommitted");
    bodyKey = "".concat(tKey, ".body_sellCommitted");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 me-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatars-stack"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, /*#__PURE__*/React.createElement(BrokerAvatar, {
    broker: operation.broker
  })), operation.goal && /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, /*#__PURE__*/React.createElement(GoalAvatar, {
    goal: operation.goal
  })), /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, /*#__PURE__*/React.createElement(InvestmentItemAvatar, {
    investmentItem: operation.investmentItem
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1"
  }, /*#__PURE__*/React.createElement("div", null, t(headerKey), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: bodyKey,
    components: {
      small: /*#__PURE__*/React.createElement("small", null),
      investmentItemAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        value: operation.investmentItemAmount,
        className: "me-1 fw-bold"
      })
    },
    values: {
      unitAbbreviation: operation.investmentItem.unitAbbreviation,
      goalDisplayableName: operation.goal ? operation.goal.displayableName : "Inversión General"
    }
  }))));
}
export default OperationRelatedNotificationToast;
OperationRelatedNotificationToast.propTypes = {
  notificationId: PropTypes.number.isRequired,
  eventTypeId: PropTypes.string.isRequired
};